export default __webpack_public_path__ + "static/media/ChristineJones-4.59de589c.jpg";